<template lang="pug">
.odds-group
  template(v-if="!!details['hdph'] ")
    template(v-for="(det, ind) in details['hdph']")
      template(v-if="det && det[9] != 0 && det[10] != 0 && det[9] != '' && det[10] != ''")
        OddsItem(:odds="det" :idx="det[7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdph" :count="ind" :details="details" homeAway="1")
      template(v-else)
        OddsDisabled
          
      template(v-if="det && det[9] != 0 && det[10] != 0 && det[9] != '' && det[10] != ''")
        OddsItem(:odds="det" :idx="det[7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdph" :count="ind" :details="details" homeAway="2")
      template(v-else)
        OddsDisabled

</template>
<script>
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import oddsItemMMO from "@/components/mobile/main/xitem/oddsItemMMO";

export default {
  components: {
    OddsItem,
    OddsDisabled,
    oddsItemMMO
  },
  mixins: [mixinHDPOUOdds],
  methods: {
    toggleMoreMarkets() {
      this.$emit("toggle-more-markets");
    },
  }
};
</script>
